import type { IEntryAuthentication } from '@app/domain/instrument/instrument.interface'
import type { AuthenticatedRequest } from '@app/rest/rest.lib';
import { authenticatedRequest } from '@app/rest/rest.lib'
import type { IApiPatient } from '@app/state/patients/helpers'
import type { IApiVisit, IApiVisitDefinition } from '@app/state/visits/helpers'

import type { IApiEntry } from './helpers'

export interface GetVisitResponse {
  visit: {
    visit: IApiVisit
    patient?: IApiPatient
  }
}

export function getVisitById(
  id: string,
): AuthenticatedRequest<GetVisitResponse> {
  return authenticatedRequest({
    method: 'get',
    url: `/api/v2/visit/${id}`,
  })
}

export interface RetrieveVisitDefinitionResponse {
  definition: IApiVisitDefinition
}

export function retrieveVisitDefinition(
  visitId: string,
): AuthenticatedRequest<RetrieveVisitDefinitionResponse> {
  return authenticatedRequest({
    method: 'get',
    url: `/api/v2/visit/${visitId}/definition`,
  })
}

export interface RetrieveVisitEntriesResponse {
  entries: Array<IApiEntry>
}

export function retrieveVisitEntries(visitId: string) {
  return authenticatedRequest({
    method: 'get',
    url: `/api/v2/visit/${visitId}/entries`,
  })
}

export interface SubmitResponsesResult {
  entry: IApiEntry
}

export function submitResponses(
  entryId: string,
  responses: Record<string, string>,
) {
  return authenticatedRequest({
    method: 'post',
    url: `/api/v2/entry/${entryId}/responses`,
    data: {
      responses: responses,
    },
  })
}

export interface DeleteResponseResult {
  entry: IApiEntry
}

export function deleteResponse(entryId: string, questionId: string) {
  return authenticatedRequest({
    method: 'delete',
    url: `/api/v2/entry/${entryId}/response`,
    data: {
      questionId: questionId,
    },
  })
}

export interface AuthenticateEntryResult {
  authentication: IEntryAuthentication
}

export function authenticateEntry(
  entryId: string,
  patientId: string,
  signature: string,
) {
  return authenticatedRequest({
    method: 'post',
    url: `/api/v2/entry/${entryId}/authenticate`,
    data: {
      patientId: patientId,
      signature: signature,
    },
  })
}

export interface WitnessEntryResult {
  authentication: IEntryAuthentication
}

export function witnessEntry(entryId: string, signature: string) {
  return authenticatedRequest({
    method: 'post',
    url: `/api/v2/entry/${entryId}/witness`,
    data: {
      signature: signature,
    },
  })
}

export interface UpdateStatusResult {
  visit: IApiVisit
}

export function updateStatus(visitId: string, status: string) {
  return authenticatedRequest({
    method: 'post',
    url: `/api/v2/visit/${visitId}/status`,
    data: {
      status: status,
    },
  })
}
